import { AppRoutingModule, components } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { reducer } from './shared/app-state/profile.reducer';
import { Ng2IziToastModule } from 'ng2-izitoast';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthGuard } from 'src/app/shared/guards/index-guards';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { MessagingService } from './shared/helper-services/messaging.service';
import { ColorPickerModule } from 'ngx-color-picker';
import { ChartsModule, ThemeService } from 'ng2-charts'
// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}
@NgModule({
    declarations: [AppComponent, components],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        Ng2IziToastModule,
        FormsModule,
        ReactiveFormsModule,
        StoreModule.forRoot({ profile: reducer }),
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireDatabaseModule,
        AngularFireMessagingModule,
        ColorPickerModule,
        ChartsModule
    ],
    providers: [AuthGuard, MessagingService, ThemeService],
    bootstrap: [AppComponent]
})
export class AppModule { }

/***** Use Monday as start day of the week *****/
defineLocale('engb', enGbLocale);
